import { Components, formControlClasses, inputLabelClasses, selectClasses, Theme } from '@mui/material';

const SELECT_CHEVRON_WIDTH = 40;

export const MuiInputLabel: Components<Theme>['MuiInputLabel'] = {
  styleOverrides: {
    root: ({ theme }) => {
      const color = theme.featureFlags.panwRebrandStubYear ? theme.palette.text.placeholder : theme.palette.grey[600];
      return {
        color,
        // Outlined labels use z-index 1 in MUI, and CombinedControls sets elements to z-index 1
        // on hover so the border of the hovered element shows, as we've stacked inputs and buttons
        // next to each other. Setting z-index to 2 here so we can keep the label strictly above
        // the hovered element.
        ...(theme.featureFlags.panwRebrandStubYear && {
          [`&.${inputLabelClasses.outlined}`]: {
            zIndex: 2,
          },
          [`&.${inputLabelClasses.error}`]: {
            color: theme.palette.text.destructive,
          },
        }),
        // Make space for the select chevron
        [`.${formControlClasses.root}:has(.${selectClasses.select}) &.${inputLabelClasses.outlined}`]: {
          maxWidth: `calc(100% - ${SELECT_CHEVRON_WIDTH}px)`,
        },
        [`.${formControlClasses.root}:has(.${selectClasses.select}) &.${inputLabelClasses.outlined}.${inputLabelClasses.shrink}`]:
          {
            maxWidth: `calc(133% - ${SELECT_CHEVRON_WIDTH}px)`,
          },
      };
    },
    sizeSmall: {
      top: '-3px',
    },
    shrink: {
      top: '0px',
    },
  },
};
